import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SKELETON_COLOR = '#e8eef0';
const SKELETON_HIGHLIGHT = '#f5f8f9';

export class AuctionListGrouped extends React.Component {
    render() {
        return (
            <div className="mza-page">
                {/* ── Reg Bar Skeleton ── */}
                <div className="mza-reg-bar">
                    <div className="mza-reg-bar__inner">
                        {[1, 2, 3].map((n) => (
                            <React.Fragment key={n}>
                                <div className="mza-reg-bar__item">
                                    <Skeleton circle width={20} height={20} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                    <Skeleton width={80} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                    <Skeleton width={110} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                </div>
                                {n < 3 && <div className="mza-reg-bar__divider" />}
                            </React.Fragment>
                        ))}
                    </div>
                </div>

                {/* ── Results Header Skeleton ── */}
                <div className="mza-results-header">
                    <div className="mza-results-header__inner">
                        <Skeleton width={220} height={40} borderRadius={12} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                        <Skeleton width={80} height={40} borderRadius={12} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                        <Skeleton width={100} height={16} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                            <Skeleton width={64} height={34} borderRadius={8} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                        </div>
                    </div>
                </div>

                {/* ── Main Layout Skeleton ── */}
                <div className="mza-main">
                    <div className="mza-main__inner">
                        {/* Sidebar Skeleton */}
                        <aside className="mza-sidebar">
                            <div style={{ marginBottom: 20 }}>
                                <Skeleton width={120} height={18} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                            </div>

                            <Skeleton width="100%" height={44} borderRadius={12} baseColor="#0c8da2" highlightColor="#14b8a6" style={{ marginBottom: 16, opacity: 0.3 }} />

                            {/* Filter groups */}
                            {[1, 2].map((group) => (
                                <div key={group} style={{ borderTop: '1px solid #f0f0f0', paddingTop: 14, marginBottom: 8 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                        <Skeleton width={100} height={16} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                        <Skeleton width={16} height={16} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                    </div>
                                    {[1, 2, 3, 4].map((item) => (
                                        <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                                            <Skeleton circle width={18} height={18} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                            <Skeleton width={90 + Math.random() * 40} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </aside>

                        {/* Card Grid Skeleton */}
                        <div className="mza-grid-area">
                            <div className="mza-card-grid">
                                {[1, 2, 3, 4, 5, 6].map((card) => (
                                    <div key={card} className="mza-card-grid__item">
                                        <div style={{
                                            background: '#fff',
                                            borderRadius: 16,
                                            border: '1px solid #e5e7eb',
                                            overflow: 'hidden',
                                        }}>
                                            <Skeleton
                                                width="100%"
                                                height={180}
                                                baseColor={SKELETON_COLOR}
                                                highlightColor={SKELETON_HIGHLIGHT}
                                                style={{ display: 'block', lineHeight: 1 }}
                                            />
                                            <div style={{ padding: '16px 18px' }}>
                                                <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
                                                    <Skeleton width={50} height={22} borderRadius={6} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                    <Skeleton width={70} height={22} borderRadius={6} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                    <Skeleton width={40} height={22} borderRadius={6} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                </div>
                                                <Skeleton width="85%" height={16} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} style={{ marginBottom: 6 }} />
                                                <Skeleton width="60%" height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} style={{ marginBottom: 14 }} />
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                                                    <Skeleton width={100} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                    <Skeleton width={70} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
                                                    <Skeleton width={90} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                    <Skeleton width={80} height={14} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                </div>
                                                <div style={{ display: 'flex', gap: 4 }}>
                                                    {[1, 2, 3, 4].map((t) => (
                                                        <Skeleton key={t} width={44} height={36} borderRadius={6} baseColor={SKELETON_COLOR} highlightColor={SKELETON_HIGHLIGHT} />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}